import './SingleCard.css'

export default function SingleCard({ card, handleChoice, flipped, disabled }) {

    const handleClick = () => {
        if(!disabled) {
            handleChoice(card)
        }
    }

  return (
        <div className='card-game'>
          <div className={flipped ? "flipped" : ""}>
            <img className='front' src={card.src} alt="card front"/>
            <img 
            className='back' 
            src="https://i.imgur.com/uvbdb5w.jpeg" 
            onClick={handleClick} 
            alt="card back"/>
          </div>
        </div>
  )
}
